import { Link } from "@inertiajs/react"
import { BookOpen, Folder, LayoutGrid } from "lucide-react"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { NavFooter } from "@/components/nav-footer"
import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import { dashboardPath } from "@/routes"
import type { NavItem } from "@/types"

import AppLogo from "./app-logo"

export function AppSidebar() {
  const { t } = useTranslation()

  const mainNavItems: NavItem[] = useMemo(
    () => [
      {
        title: t("app_sidebar.dashboard"),
        href: dashboardPath(),
        icon: LayoutGrid,
      },
    ],
    [t],
  )

  const footerNavItems: NavItem[] = useMemo(
    () => [
      {
        title: t("app_sidebar.repository"),
        href: "https://github.com/inertia-rails/react-starter-kit",
        icon: Folder,
      },
      {
        title: t("app_sidebar.documentation"),
        href: "https://inertia-rails.dev",
        icon: BookOpen,
      },
    ],
    [t],
  )

  return (
    <Sidebar collapsible="icon" variant="inset">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <Link href={dashboardPath()} prefetch>
                <AppLogo />
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>

      <SidebarContent>
        <NavMain items={mainNavItems} />
      </SidebarContent>

      <SidebarFooter>
        <NavFooter items={footerNavItems} className="mt-auto" />
        <NavUser />
      </SidebarFooter>
    </Sidebar>
  )
}
